import React from "react";
import { getUnitOptions, isNumber } from "../utils/utils";
import SpecManagerInput from "./SpecManagerInput";
import SpecManagerSelect from "./SpecManagerSelect";

export default function SpecsRange({ specValues, unitOptions, onChange }) {
  const units = getUnitOptions(unitOptions);
  const [rangeFrom, rangeTo, unitValue] = specValues;

  const fromInvalid = (!rangeFrom && rangeTo) || (rangeFrom && !isNumber(rangeFrom));
  const toInvalid = (!rangeTo && rangeFrom) || (rangeTo && !isNumber(rangeTo));

  return (
    <div className="SpecManager_SpecInputRow">
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--value">
        <SpecManagerInput
          placeholder="eg: 0.75"
          value={rangeFrom}
          additionalClassName={fromInvalid ? "SpecManager_Input--rangeMissing" : ""}
          onChange={(value) => onChange([value, rangeTo, unitValue])}
        />
      </div>
      <span className="SpecManager_SpecInputRowDivider">-</span>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--value">
        <SpecManagerInput
          placeholder="eg: 2.0"
          value={rangeTo}
          additionalClassName={toInvalid ? "SpecManager_Input--rangeMissing" : ""}
          onChange={(value) => onChange([rangeFrom, value, unitValue])}
        />
      </div>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--unit">
        <SpecManagerSelect
          options={units}
          selectedValue={unitValue === "%" ? "%" : unitValue || "None"}
          onSelect={(selected) => onChange([rangeFrom, rangeTo, selected])}
        />
      </div>
    </div>
  );
}
